import errorReporting from '../ErrorReporting';
import { getCookie } from './getCookie';
import store from '../../redux/store';
import { logout } from '../../redux/actions';

type AuthUserClientUser = {
	id: string;
	email: string;
	userID: string;
	userType: 'ClientUser';
	isAdmin: false;
	isSuperAdmin?: false;
	isOwner?: false;
	isLoggedIn: true;
	groups: [];
	impersonatingUser: null;
};
type AuthUserOrgUser = {
	id: string;
	email: string;
	userID: string;
	userType: 'OrgUser';
	isAdmin: boolean;
	isSuperAdmin?: false;
	isOwner?: boolean;
	isLoggedIn: true;
	groups: [];
	impersonatingUser: null;
	user: {
		id: string;
		email: string;
		onboardingCompleted?: boolean;
		acceptedTerms?: boolean;
	};
};

export type AuthUser = AuthUserClientUser | AuthUserOrgUser;

/**
 * Get the currently logged in user and auth token from the cookies.
 */
export const getInfoFromCookie = (
	cookieString: string
): [string, AuthUser | undefined] | [] => {
	const decodedCookie = decodeURIComponent( cookieString );
	const token = getCookie( 'Authorization=', decodedCookie );
	const user = getCookie( 'CurrentUser=', decodedCookie );
	try {
		if ( user ) {
			const decodedUser: AuthUser = JSON.parse( user );
			return [ token, decodedUser ];
		} else {
			return [ token, undefined ];
		}
	} catch ( error ) {
		// If we get data in the CurrentUser cookie that is not JSON, it'll get caught and logged
		errorReporting.captureErrorInSentry( error, undefined, {
			cookieString,
			decodedCookie,
		} );
		/* only pass true to do redirect if we're client-side because we don't have the request
        headers here, and no window otherwise */
		const doRedirect = typeof window !== 'undefined';
		store.dispatch( logout( doRedirect ) );
		return [];
	}
};
